import $ from 'jquery'
import drawLayer from '../drawLayer'
import { GeoJSON } from 'ol/format'
import { transformExtentWithOptions } from 'ol/format/Feature'
import VectorSource from 'ol/source/Vector'

/**
 * @module
 * @api
 */

/**
 * UI tool class
 *
 * @param {string} position
 * @constructor
 */
export default function Draw(config) {
  $.extend(this, config || {})
  this.listeners = []
  this.stashedListeners = []
  this.stashedFeatures = []
  this.format = new GeoJSON()
}

/**
 * Add event listener
 * @param {string} type event type
 * @return {function} listener callback function
 * @memberof! module:api/Draw#
 * @api
 */
Draw.prototype.on = function(type, callback) {
  this.listeners.push({
    type: type,
    callback: callback
  })
}

/**
 * Remove event listener
 * @param {string} type event type
 * @return {function} listener callback function
 * @memberof! module:api/Draw#
 * @api
 */
Draw.prototype.un = function(type, callback) {
  this.listeners
    .filter(
      listener => listener.type === type && listener.callback === callback
    )
    .forEach(listener => {
      const index = this.listeners.indexOf(listener)
      this.listeners.splice(index, 1)
    })
}

/**
 * Create an event trigger
 * @return {function} trigger function to handle changes in draw interaction
 */
Draw.prototype.createTrigger = function() {
  return e => {
    let geoJSON
    let originalGeoJSON
    if (this.listeners.length > 0) {
      if (e.feature) {
        geoJSON = this.format.writeFeature(e.feature)
      } else if (e.features) {
        geoJSON = this.format.writeFeatures(e.features.getArray())
      }
      if (e.originalFeature) {
        originalGeoJSON = this.format.writeFeature(e.originalFeature)
      }
    }
    this.listeners
      .filter(listener => listener.type.indexOf(e.type) > -1)
      .forEach(listener => {
        listener.callback({
          type: e.type,
          geoJSON: geoJSON,
          originalGeoJSON: originalGeoJSON,
          data: e.data
        })
      })
  }
}

/**
 * Clear draw layer
 * @api
 */
Draw.prototype.clear = function() {
  drawLayer.getSource().clear()
}

/**
 * Add GeoJSON features to draw layer
 * @param {string} geoJSON
 * @memberof! module:api/Draw#
 * @api
 */
Draw.prototype.add = function(geoJSON) {
  if (geoJSON) {
    this.geometry.addGeoJSON(drawLayer, geoJSON)
  }
}

Draw.prototype.stashListeners = function() {
  this.stashedListeners = this.listeners
  this.listeners = []
}

Draw.prototype.popListeners = function() {
  this.listeners = this.stashedListeners
  this.stashedListeners = []
}

Draw.prototype.stashSource = function() {
  this.stashedFeatures = [...drawLayer.getSource().getFeatures()]
  drawLayer.getSource().clear()
}

Draw.prototype.popSource = function() {
  drawLayer.getSource().clear()
  drawLayer.getSource().addFeatures(this.stashedFeatures)
  this.stashedFeatures = []
}